import React from 'react';
import s from './AppWrapper.module.scss';

export const AppWrapper = (props) => {
  const { children } = props;

  return <div className={s.appWrapper}>{children}</div>;
};
